// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"f5b5920f","213":"cee8f3cc","437":"6b3f1a7c","453":"e0eb14ff","455":"bac873a7","532":"a10987ff","679":"764355db","818":"6f8e3184","830":"5e87ae6a"}[chunkId] + ".chunk.js";
};